import { getForm as getState } from "modules/root/root-selectors";
import { createSelector } from "reselect";

export const getExistingFormIds = createSelector(
  getState,
  state => state && Object.keys(state)
);



// WEBPACK FOOTER //
// ./src/modules/forms/forms-selectors.js